<div class="grid" *ngIf="deliverableDetail$ | async as deliverableDetail">
  <app-deliverable-cr-update-section [deliverableDetail]="deliverableDetail"></app-deliverable-cr-update-section>
  <app-deliverable-soft-update-section [deliverableDetail]="deliverableDetail"></app-deliverable-soft-update-section>
</div>
<app-spinner *ngIf="loading$ | async" [absoluteOverlay]="true"></app-spinner>
